import {
  BrowserRouter,
  Routes,
  Route,
  Outlet,
  Navigate,
} from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import "./assets/css/style.css";
import {
  AdminRoute,
  AdminOrDealerRoute,
  AdminOrDealerWhoHaveAllowDealerCreationRoute,
} from "./components/utils/RouteProtect";
import NotFound from "./components/utils/NotFound";
import Header from "./components/layout/Header";
import Footer from "./components/layout/Footer";
import Sidebar from "./components/layout/Sidebar";
import Signin from "./pages/Signin";
import ForgetPassword from "./pages/ForgetPassword";
import ResetPassword from "./pages/ResetPassword";
import Dashboard from "./pages/Dashboard";
import Dealer from "./pages/Admin/Dealer";
import User from "./pages/Admin/User";
import ManualAddFund from "./pages/Admin/ManualAddFund";
import Network from "./pages/Config/Network";
import Plan from "./pages/Config/Plan";
import PlanPriceMapping from "./pages/Config/PlanPriceMapping";
import MyProfile from "./pages/Profile/MyProfile";
import HardRefershComponent from "./components/utils/HardRefershComponent";
import { useState, useEffect } from "react";
import ActivationStatus from "./pages/Activation/ActivationStatus/ActivationStatus";
import MDNSwap from "./pages/Activation/MDNSwap/MDNSwap";
import ChatrActivationRequest from "./pages/Activation/ChatrActivationRequest/ChatrActivationRequest";
import SIMPINnventory from "./pages/Inventory/SIMPINInventory/SimPinInventory";
import ChatrActivationReport from "./pages/Report/Chatr Activation Report/ChatrActivationReport";
import MDNSwapReport from "./pages/Report/MDN Swap Report/MDNSwapReport";
import ChatrRechargeRequest from "./pages/Activation/Chatr Recharge Request/ChatrRechargeRequest";
import RechargePlan from "./pages/Config/Recharge Plan";
import RechargePriceMapping from "./pages/Config/RechargePriceMapping";

const VERSION_CODE = process.env.REACT_APP_VERSION_CODE;

function App() {
  const [versionMatch, setVersionMatch] = useState(true);

  const Layout = () => {
    return (
      <>
        <div className="wrapper">
          <Sidebar />
          <Header />
          <div id="content-page" class="content-page">
            <Outlet />
          </div>
        </div>
        <Footer />
      </>
    );
  };

  const isAuthenticated = () => {
    let token = localStorage.getItem("mvno_admin_token");
    if (token) {
      let decodedToken = jwtDecode(token);
      let currentDate = new Date();
      if (decodedToken.exp * 1000 < currentDate.getTime()) {
        localStorage.removeItem("mvno_admin_token");
        return false;
      } else {
        return true;
      }
    } else {
      localStorage.removeItem("mvno_admin_token");
      return false;
    }
  };

  const checkVersion = () => {
    const storedVersion = localStorage.getItem("version_code");
    if (storedVersion && storedVersion !== VERSION_CODE) {
      setVersionMatch(false);
    } else {
      setVersionMatch(true);
    }
  };

  useEffect(() => {
    checkVersion();
  }, []);

  useEffect(() => {
    const observer = new MutationObserver(() => {
      checkVersion();
    });

    observer.observe(document, {
      subtree: true,
      childList: true,
    });

    window.addEventListener("storage", checkVersion);
    return () => {
      observer.disconnect();
      window.removeEventListener("storage", checkVersion);
    };
  }, []);

  if (!versionMatch) {
    return <HardRefershComponent />;
  }

  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<NotFound />} />
          <Route path="/404" element={<NotFound />} />
          <Route
            path="/sign-in"
            element={isAuthenticated() ? <Navigate to="/" /> : <Signin />}
          />
          <Route
            path="/forget-password"
            element={
              isAuthenticated() ? <Navigate to="/" /> : <ForgetPassword />
            }
          />
          <Route
            path="/reset-password/*"
            element={
              isAuthenticated() ? <Navigate to="/" /> : <ResetPassword />
            }
          />

          <Route
            path="/"
            element={
              !isAuthenticated() ? <Navigate to="/sign-in" /> : <Layout />
            }
          >
            {/* common route */}
            <Route path="/" element={<Dashboard />} />
            <Route
              path="/dealer"
              element={
                <AdminOrDealerWhoHaveAllowDealerCreationRoute>
                  <Dealer />
                </AdminOrDealerWhoHaveAllowDealerCreationRoute>
              }
            />
            <Route
              path="/user"
              element={
                <AdminOrDealerRoute>
                  <User />
                </AdminOrDealerRoute>
              }
            />
            <Route path="/my-profile" element={<MyProfile />}></Route>
            <Route
              path="/plan"
              element={
                <AdminOrDealerRoute>
                  <Plan />
                </AdminOrDealerRoute>
              }
            />
            <Route
              path="/recharge-plan"
              element={
                <AdminOrDealerRoute>
                  <RechargePlan />
                </AdminOrDealerRoute>
              }
            />

            <Route
              path="/chatr-activation"
              element={<ChatrActivationRequest />}
            />

            <Route path="/activation-status" element={<ActivationStatus />} />

            <Route
              path="/manual-add-fund"
              element={
                <AdminRoute>
                  <ManualAddFund />
                </AdminRoute>
              }
            />

            <Route
              path="/network"
              element={
                <AdminRoute>
                  <Network />
                </AdminRoute>
              }
            />

            <Route
              path="/plan-price-mapping"
              element={
                <AdminRoute>
                  <PlanPriceMapping />
                </AdminRoute>
              }
            />
            <Route
              path="/recharge-price-mapping"
              element={
                <AdminRoute>
                  <RechargePriceMapping />
                </AdminRoute>
              }
            />

            <Route
              path="/sim-pin-inventory"
              element={
                <AdminRoute>
                  <SIMPINnventory />
                </AdminRoute>
              }
            />
            <Route path="/mdn-swap" element={<MDNSwap />}></Route>
            <Route
              path="/chatr-activation-report"
              element={<ChatrActivationReport />}
            ></Route>
            <Route path="/mdn-swap-report" element={<MDNSwapReport />}></Route>
            <Route
              path="/chatr-recharge"
              element={<ChatrRechargeRequest />}
            ></Route>
          </Route>
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
